'use strict';

wbApp.controller('InvoicesCtrl', ['$scope', '$modal', '$q', '$window', '$translate', '$timeout', '$filter', 'semesterSvc',
    'invoiceSvc', 'messageBoxSvc', 'notificationSvc', 'accountingBookSvc', 'securitySvc', 'gridSortSvc', 'localStorageService',
function ($scope, $modal, $q, $window, $translate, $timeout, $filter, semesterSvc,
    invoiceSvc, messageBoxSvc, notificationSvc, accountingBookSvc, securitySvc, gridSortSvc, localStorageService) {

    $scope.semesterDataRange = 1; // 1 - semester, 2 - from to
    $scope.fromDate = moment().subtract(3, 'M').startOf('day').toDate();
    $scope.toDate = moment().startOf('day').toDate();

    if (localStorageService.isSupported)
    {
        $scope.semesterDataRange = localStorageService.get('semesterDataRange') || 1;
    }

    $scope.customFilter = { accountingBooks: [] };
    $scope.rawInvoices = [];
    $scope.invoices = [];
    $scope.filteredRows = [];

    $scope.accountingBooks = accountingBookSvc.getAllAsync();

    function preFilter() {
        $q.all([$scope.rawInvoices.$promise, $scope.accountingBooks.$promise]).then(function () {
            var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
            $scope.invoices.length = 0;
            $scope.invoices.push.apply($scope.invoices,
                _.filter($scope.rawInvoices, function (o) {
                    
                    if (accountingBookIDs.length > 0) {
                        return _.includes(accountingBookIDs, o.accountingBookID);
                    }

                    return true;
                })
            );
        });
    }

    $scope.onDataRangeChanged = function () {
        if (localStorageService.isSupported) {
            localStorageService.set('semesterDataRange', $scope.semesterDataRange);
        }

        if ($scope.semesterID != null) {
            loadData();
        }

        if ($scope.gridSettings.gridInstance) {
            if ($scope.semesterDataRange === 1) {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", false);
            } else {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", true);
            }
        }
    }

    function loadData() {
        if ($scope.semesterDataRange === 1) {
            $scope.rawInvoices = invoiceSvc.getInvoiceEvidenceBySemester($scope.semesterID);
        } else {
            $scope.rawInvoices = invoiceSvc.getInvoiceEvidenceByDateRange(
                $scope.fromDate, $scope.toDate, true);
        }
        preFilter();
    }

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    $scope.gridSettings = {
        name: 'invoices',
        columns: [
            {
                name: 'semesterColumn',
                dataField: 'semesterID',
                caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '120px',
                calculateCellValue: function (rowData) {
                    return $filter('semester')(rowData.semesterID);
                },
                visible: $scope.semesterDataRange === 2
            },
            { dataField: 'recordNumber', caption: $translate.instant('TXT_LBL_INVOICE_NO'), dataType: 'number', width: '100px', sortOrder: 'desc' },
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'customerOperatorID',
                caption: $translate.instant('TXT_LBL_PARENT') + ' ID',
                dataType: 'number',
                width: '100px',
                visible: false
            },
            {
                dataField: 'operatorFullName', caption: $translate.instant("TXT_LBL_PARENT"), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'operatorFullName') }
            },
            {
                dataField: 'typeID',
                caption: $translate.instant("TXT_LBL_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('invoiceForType')(rowData.typeID);
                },
                width: '55px'
            },
            { dataField: 'subject', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string' },
            { dataField: 'invoiceDate', caption: $translate.instant('TXT_LBL_INVOICE_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'total', caption: $translate.instant('TXT_LBL_AMOUNT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'paymentSum', caption: $translate.instant('TXT_LBL_PAYMENTS_SUM'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            {
                dataField: 'latest',
                caption: $translate.instant('TXT_LBL_VALID'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('invoiceValid')(rowData.latest);
                },
                width: '80px'
            },
            { dataField: 'accountingBookID', caption: $translate.instant('TXT_LBL_ACCOUNTING_BOOK'), dataType: 'number', visible: false },
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.notLatest) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },       
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintInvoice(row.invoiceID, 'pdf'); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_INVOICE_ALL'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports');
            },
            callback: function (row, allRows) { onPrintInvoiceAll(row, allRows); }
        },
        {
            text: $translate.instant('TXT_MENU_STORMWARE_EXPORT'),            
            callback: function (row, allRows) { onStormwareExportRequested(row, allRows); }
        },
        {
            text: $translate.instant('TXT_MENU_MONEYS3_PURCHASE_ORDER_EXPORT'),
            callback: function (row, allRows) { onMoneyS3ExportRequested(row, false); }
        },
        {
            text: $translate.instant('TXT_MENU_MONEYS3_INVOICE_EXPORT'),
            callback: function (row, allRows) { onMoneyS3ExportRequested(row, true); }
        },
        {
            text: $translate.instant('TXT_MENU_CSV_EXPORT'),
            callback: function (row, allRows) { onCsvExportRequested(row, allRows); }
        },
        {
            text: $translate.instant('TXT_EXPORT_INVOICE_TO_EXCEL'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintInvoice(row.invoiceID, 'xls'); }
        }]
    }


    $scope.onFilterApplied = function (filteredRows) {
        $scope.filteredRows = filteredRows;
    }

    function onPrintInvoiceAll(row) {
        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICES_PRINT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_PRINT').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        var invoiceIDs = encodeURIComponent(JSON.stringify(_.map($scope.filteredRows, 'invoiceID')));

        $window.open('/Admin/Report/InvoiceAll?InvoiceIDs=' + invoiceIDs,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onStormwareExportRequested(row) {

        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            invoiceSvc.getStormwareInvoiceExport(row.accountingBookID, _.map($scope.filteredRows, 'invoiceID'),
                onStormwareExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_SERVER_ERROR'),
                    notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_INVOICE_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }

    function onMoneyS3ExportRequested(row, exportAsInvoices) {

        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            invoiceSvc.getMoneyS3InvoiceExport(
                row.accountingBookID, 
                _.map($scope.filteredRows, 'invoiceID'),
                exportAsInvoices,
                onMoneyS3ExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_SERVER_ERROR'),
                    notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_INVOICE_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }

    function onCsvExportRequested(row) {

        var uniqueByAccountingBooks = _.uniqBy($scope.filteredRows, 'accountingBookID');
        if (uniqueByAccountingBooks.length > 1) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_ERROR_INVOICE_EXPORT_GENERATION',
                message: $translate.instant('TXT_TEXT_TOO_MANY_ACCOUNTING_BOOKS_IN_EXPORT').f(uniqueByAccountingBooks.length),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        function onYesClicked() {
            invoiceSvc.getCsvInvoiceExport(row.accountingBookID, _.map($scope.filteredRows, 'invoiceID'),
                onCsvExportGenerated,
                function (error) {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_SERVER_ERROR'),
                        notificationSvc.translateError(error));
                });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_INVOICE_EXPORT_GENERATION',
            message: $translate.instant('TXT_TEXT_CONFIRM_INVOICE_EXPORT_GENERATION').f($scope.filteredRows.length),
            buttons: [{
                text: 'TXT_BTN_CANCEL'
            }, {
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked
            }]
        });
    }

    function onStormwareExportGenerated(data) {
        $("#dataDownloadIFrame").remove();
        $("body").append("<iframe id='dataDownloadIFrame' src='/Api/Invoices/Download?fileName=" + data.fileName + "&prefix=pohoda' style='height: 0px;' ></iframe>");
    }
    
    function onMoneyS3ExportGenerated(data) {
        $("#dataDownloadIFrame").remove();
        $("body").append("<iframe id='dataDownloadIFrame' src='/Api/Invoices/Download?fileName=" + data.fileName + "&prefix=moneyS3' style='height: 0px;' ></iframe>");
    }

    function onCsvExportGenerated(data) {
        $("#dataDownloadIFrame").remove();
        $("body").append("<iframe id='dataDownloadIFrame' src='/Api/Invoices/Download?fileName=" + data.fileName + "&prefix=csv' style='height: 0px;' ></iframe>");
    }
    function onPrintInvoice(invoiceID, format) {

        if (format == 'xls') {
            $("#dataDownloadIFrame").remove();
            $("body").append("<iframe id='dataDownloadIFrame' src='/Admin/Report/Invoice?ReportID=" + invoiceID + "&ReportIDType=1&format=" + format + "' style='height: 0px;' ></iframe>");
        } else {
            $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
                '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        }
    }

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            loadData();
            $scope.selectedInvoice = null;
            preFilter();
        }
    });

    $q.all([semesterSvc.getDefaultAsync()])
    .then(function (data) {
        if (data[0]) {
            $scope.semesterID = data[0].id;
        }

        if ($scope.semesterID) {
            // get invoices
            loadData();
        }        
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            // get invoices
            loadData();
            $scope.selectedInvoice = null;            
        }
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedInvoice = data;
    }

}]);
